import type {ValueOf} from '@myparcel-frontend/types';
import {TierName} from '@/types/subscriptions/tiers';

export const MyAnalyticsProductId = {
  Start: 4700,
  Plus: 4701,
  Premium: 4702,
  Max: 4703,
} as const;

export const MyAnalyticsTierName = {
  Start: TierName.Start,
  Plus: TierName.Plus,
  Premium: TierName.Premium,
  Max: TierName.Max,
} as const;

export const MY_ANALYTICS_IDS_TO_NAMES = {
  [MyAnalyticsProductId.Start]: MyAnalyticsTierName.Start,
  [MyAnalyticsProductId.Plus]: MyAnalyticsTierName.Plus,
  [MyAnalyticsProductId.Premium]: MyAnalyticsTierName.Premium,
  [MyAnalyticsProductId.Max]: MyAnalyticsTierName.Max,
};

export const toMyAnalyticsTierName = <T extends ValueOf<typeof MyAnalyticsProductId>>(id: T) => {
  return MY_ANALYTICS_IDS_TO_NAMES[id];
};
